import React, { useEffect } from 'react';
import { WppInlineMessage, WppSegmentedControl, WppSegmentedControlItem } from 'buildingBlocks';
import { BulkUploadTabs } from 'containers/BulkCreateStrategyWizard/steps/AttachFlights/constants';
import { Member } from 'utils/types';
import { bulkUploaderStyles } from 'containers/BulkCreateStrategyWizard/steps/AttachFlights/style';
import InputObjectIdsTab from './InputObjectIdsTab';
import MemberField from '../AttachFlightsModal/MemberField';
import FileUploadZone from './FileUploadZone';

type UploadTabsProps = {
  selectedTab: string
  onTabChange: (event: any) => void
  setBulkFlightIds: (ids: Array<number>) => void
  errMessage: string
  members: Array<Member>
  memberFetchError: string
  setErrMessage: (err: string) => void
  bulkUploadModalOpen: boolean
  selectedMember: Member
};

const { segmentControlStyle, errorMessageStyle, textAreaErr } = bulkUploaderStyles;

const BulkUploadModalBody = ({
  selectedTab,
  onTabChange,
  setBulkFlightIds,
  errMessage,
  members,
  memberFetchError,
  setErrMessage,
  bulkUploadModalOpen,
  selectedMember,
}: UploadTabsProps) => {
  const showError = Boolean(errMessage);
  const isInputIdTab = selectedTab === BulkUploadTabs.inputId;
  const shouldShowMemberErr: boolean = !!showError && !selectedMember;
  const shouldShowFileErr: boolean = !!showError && !!selectedMember;

  useEffect(() => {
    if (selectedMember && errMessage) {
      setErrMessage('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMember]);

  const renderErrorMessage = () => (
    <div style={{ ...errorMessageStyle, ...(isInputIdTab && !shouldShowMemberErr ? textAreaErr : {}) }}>
      <WppInlineMessage size="s" message={errMessage} type="error" />
    </div>
  );

  return (
    <>
      <WppSegmentedControl
        value={selectedTab}
        onWppChange={onTabChange}
        style={segmentControlStyle}
      >
        <WppSegmentedControlItem value={BulkUploadTabs.uploadFile}>
          {BulkUploadTabs.uploadFile}
        </WppSegmentedControlItem>
        <WppSegmentedControlItem value={BulkUploadTabs.inputId}>
          {BulkUploadTabs.inputId}
        </WppSegmentedControlItem>
      </WppSegmentedControl>
      <div className={shouldShowMemberErr ? 'bulk-upload-body-container' : ''}>
        <MemberField
          members={members}
          memberFetchError={memberFetchError}
        />
        {shouldShowMemberErr && renderErrorMessage()}
      </div>
      {isInputIdTab ? (
        <InputObjectIdsTab
          setBulkFlightIds={setBulkFlightIds}
          shouldShowFileErr={shouldShowFileErr}
        />
      ) : (
        <FileUploadZone
          setBulkFlightIds={setBulkFlightIds}
          setErrMessage={setErrMessage}
          bulkUploadModalOpen={bulkUploadModalOpen}
          shouldShowFileErr={shouldShowFileErr}
        />
      )}
      {shouldShowFileErr && renderErrorMessage()}
    </>
  );
};

export default BulkUploadModalBody;
